/**
 * Fetches marketing strip content from the CMS based on a delivery key.
 *
 * This composable retrieves marketing strip data using the provided
 * delivery key, current locale, and optional query parameters.
 *
 * @param {string} deliveryKey - The key used to identify the specific marketing strip
 * @returns {Promise<Object>} An object containing the fetched marketing strip data
 *
 * @example
 * const { data } = await useMarketingStrip('homePageMarketingStrip')
 * console.log(data.value) // Displays the marketing strip content
 */
export async function useMarketingStrip(deliveryKey: string) {
  const localePath = useLocalePath()
  const query = {
    locale: localePath(''),
    vse: useRoute().query.vse,
    contentId: useRoute().query.contentId,
    deliveryKey: deliveryKey,
  }

  const { data } = await useFetch('/api/cms/getMarketingStrip', {
    query,
  })

  return {
    data,
  }
}
